import { useNavigate } from "react-router-dom";

import { PlusOutlined } from "@ant-design/icons";
import { Button, Typography } from "antd";

import useDeviceType from "../../../utils/deviceType";
import { UserTable } from "../components/UserTable";

const UserManagement = () => {
  const { Title } = Typography;
  const navigate = useNavigate();
  const { isMobile } = useDeviceType();

  return (
    <div style={{ paddingInline: 20 }}>
      {isMobile ? (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "baseline",
            marginBottom: "1rem",
            width: "100%",
          }}
        >
          <Title level={3} style={{ marginBottom: 0, marginTop: "1em" }}>
            User Listing
          </Title>
          <Button
            type="primary"
            onClick={() => navigate("/users/new")}
            style={{ marginTop: "1em", height: "auto" }}
          >
            <PlusOutlined />
            Create User
          </Button>
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "nowrap",
          }}
        >
          <Title level={3} style={{ marginBottom: "1em" }}>
            User Listing
          </Title>
          <Button
            type="primary"
            style={{
              display: "flex",
              alignItems: "center",
            }}
            onClick={() => navigate("/users/new")}
          >
            <PlusOutlined />
            Create User
          </Button>
        </div>
      )}
      <UserTable />
    </div>
  );
};

export default UserManagement;
